import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import TemplatesContent from "../../components/Pages/Templates";

const { displayName } = config;

export default function Templates() {
  useEffect(() => {
    document.title = `${displayName}: Templates`;
  }, []);

  return (
    <Layout title="Templates">
      <TemplatesContent />
    </Layout>
  );
}
